export const ADDINT_INITIALIZE = 'PAGE_ADDINT_INITIALIZE';
export const ADDINT_SAVE_CONNECTION = 'PAGE_ADDINT_SAVE_CONNECTION';
export const ADDINT_SELECT_APP = 'PAGE_ADDINT_SELECT_APP';
export const ADDINT_CHANGE_NAME = 'PAGE_ADDINT_CHANGE_NAME';

export function initialize() {
  return {
    type: ADDINT_INITIALIZE
  };
}

export function savingConnection() {
  return {
    type: ADDINT_SAVE_CONNECTION
  };
}

export function selectApp(appID) {
  return {
    type: ADDINT_SELECT_APP,
    appID
  };
}

export function changeName(name) {
  return {
    type: ADDINT_CHANGE_NAME,
    name
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/admin/AddIntegration.js